export enum WorkStandardFormFields {
  NonDrvTimeTypeId = 'nonDrvTimeTypeId',
  WrkStndrdSequenceNbr = 'wrkStndrdSequenceNbr',
  MinimumDuration = 'minimumDuration',
  MaxDuration = 'maxDuration',
  TrlrQuantity = 'trlrQuantity',
  ListActionCd = 'listActionCd',
  AuditInfo = 'auditInfo'
}
